document.querySelectorAll(".categories-item").forEach((item) => {
  item.addEventListener("click", function () {
    const link = this.querySelector(".full-link");
    if (link) {
      window.location.href = link.href;
    }
  });
});

document.querySelectorAll(".categories-item a").forEach((link) => {
  link.addEventListener("focus", () => {
    link.parentElement.classList.add("focus");
  });
  link.addEventListener("blur", () => {
    link.parentElement.classList.remove("focus");
  });
});
